import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import { SERVICES_MAIN_PAGE_PATH } from "utils/constants/paths";

const ServicesMainPage = Loadable(React.lazy(() => import("./View")));

export const ServicesMainPageRoute: IRouteItem = {
  path: SERVICES_MAIN_PAGE_PATH,
  element: React.createElement(ServicesMainPage),
  name: "Services Main Page",
};
